import { styled } from '../theme';

const TableHead = styled('thead')(({ theme }) => ({}));

export default TableHead;
